<template>
  <el-button type="danger"
             size="mini"
             @click="onSubmit"
             v-if="status === 0 || status === 1">
    <slot></slot>
  </el-button>


</template>

<script>

export default {
  components: {},
  props: {
    taskid: String,
    status: Number,
  },
  methods: {
    onSubmit () {
      return this.$confirm('您确定要删除吗？', '提示', {type: 'warning'}).then(_ => {
        return request.alert('taskDelete', {taskid: this.taskid}).then(_ => {
          this.$message.success('删除成功！')
          this.$store.commit('OPEN_LOADING')
          setTimeout(() => {
            this.$emit('search')
            this.$store.commit('CLOSE_LOADING')
          }, 2000)
        })
      })
    },
  },
}
</script>




// WEBPACK FOOTER //
// src/views/task/components/buttons/TaskDeleteButton.vue